import { Toast } from "src/app/ui/components/toast/toast";
import { ExportOrderKey } from "src/app/ui/models/domains/pbm/exports/export-order-key";
import { BaseSasFileExportRequest, IFileExportOrderRequest } from "src/app/ui/models/domains/pbm/exports/file-export-order-request";
import { FileExportService } from "src/app/ui/services/file-export.service";
import { ClustersService } from "src/app/ui/services/pbm/clusters.service";

export class AddBatchExportOrderRequest extends BaseSasFileExportRequest {
  constructor(
    private clusterService: ClustersService, 
    toast: Toast, 
    fileExportService: FileExportService, 
    private request: ExportOrderKey) {
      super(fileExportService, toast)
    }

  public getFileExportName(): string {
    return `Produtos-do-cluster`;
  }

  public async orderExport(): Promise<ExportOrderKey> {
    return this.request;
  }
}
